import { axiosInstanceWithToken } from 'utils/axios';
import { IFLCRequest } from '../../server/types';

export const sendFlc = async (data: IFLCRequest) => axiosInstanceWithToken().post('flc', data);
